<template>
  <a-table
    :rowKey="(record, index) => index"
    :scroll="{ x: 1000 }"
    :dataSource="dataList"
    :columns="columns"
    size="small"
    :pagination="false"
    class="mb20 "
  >
    <template #typeCode="{record}">
      <a @click="copyToClipboard(record.typeCode)" style="color: #40a9ff">{{
        record.typeCode
      }}</a>
    </template>

    <template #typeName="{record}">
      <a @click="showDraw(record)" style="color: #40a9ff">{{
        record.typeName
      }}</a>
    </template>

    <template #level="{record}">
      <a-tag v-if="record.level === 10" color="success">通知</a-tag>
      <a-tag v-if="record.level === 20" color="warning">警告</a-tag>
      <a-tag v-if="record.level === 30" color="error">错误</a-tag>
    </template>

    <template #deal="{record}">
      <a-popconfirm title="确定删除?" @confirm="onDeleted(record.typeCode)">
        <a-button type="link">删除</a-button>
      </a-popconfirm>
    </template>
  </a-table>
  <Pagination v-if="dataList && dataList.length > 0" />
</template>

<script>
import { inject, toRefs } from 'vue'
import { CopyOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

export default {
  name: 'SiteMessageTable',

  setup() {
    const state = inject('state')
    const copyToClipboard = text => {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            message.success('复制成功')
          })
          .catch(err => {
            message.error('复制失败')
            console.error('复制失败:', err)
          })
      } else {
        // 兼容性处理
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        try {
          const successful = document.execCommand('copy')
          if (successful) {
            message.success('复制成功')
          } else {
            message.error('复制失败')
          }
        } catch (err) {
          message.error('复制失败')
          console.error('复制失败:', err)
        }
        document.body.removeChild(textArea)
      }
    }
    return {
      ...toRefs(state),
      copyToClipboard,
      columns: [
        {
          title: '消息类型组',
          dataIndex: 'groupName',
          width: 100
        },
        {
          title: '消息类型编码',
          dataIndex: 'typeCode',
          width: 150,
          slots: { customRender: 'typeCode' }
        },
        {
          title: '消息类型名称',
          dataIndex: 'typeName',
          width: 200,
          slots: { customRender: 'typeName' }
        },
        {
          title: '通知等级',
          dataIndex: 'level',
          width: 80,
          slots: { customRender: 'level' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 100
        },
        {
          title: '更新时间',
          dataIndex: 'lastUpdateTime',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'deal',
          width: 100,
          fixed: 'right',
          slots: { customRender: 'deal' }
        }
      ]
    }
  }
}
</script>

<style scoped></style>
